module.exports = __webpack_public_path__ + "static/bg_fifa.8efaa516.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/bg_fifa.jpg
// module id = 766
// module chunks = 79611799117203